import { Component, OnInit } from '@angular/core';
// import { RegistrationService } from '../service/registration/registration.service';
import { FormControl, FormGroup, Validators, AbstractControl, ValidationErrors } from "@angular/forms";
import { ToastrService } from 'ngx-toastr';
import { ChangePasswordService } from '../../service/change-password/change-password.service';
import { Router } from '@angular/router';
// import { PasswordStrengthValidator } from 'src/app/password-strength.validators';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent {

    constructor(
        private changepasswordservice: ChangePasswordService,
        private toastra: ToastrService,
        private router: Router,
    ) { }

    // formGroup: FormGroup;

    OldNotMatch: boolean = false;
    OldConfirmMatch = false;
    hidePassword: boolean = true;
    hideConfirmPassword: boolean = true;
    hideOldPassword: boolean = true;
    Loader: boolean = false;

    //formpassword: any;
    formpassword = {
        oldpassword: '',
        password: '',
        confirmPassword: '',
    };
    errors = {
        oldpassword: '',
        password: '',
        confirmPassword: '',
    };

    // Function to validate password strength
    validatePasswordStrength(value: string): { passwordStrength?: string } | null {

        const upperCaseCharacters = /[A-Z]+/g;
        if (!upperCaseCharacters.test(value)) {
            return { passwordStrength: 'Password must contain at least one uppercase letter.' };
        }

        const lowerCaseCharacters = /[a-z]+/g;
        if (!lowerCaseCharacters.test(value)) {
            return { passwordStrength: 'Password must contain at least one lowercase letter.' };
        }

        const numberCharacters = /[0-9]+/g;
        if (!numberCharacters.test(value)) {
            return { passwordStrength: 'Password must contain at least one number.' };
        }

        const specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
        if (!specialCharacters.test(value)) {
            return { passwordStrength: 'Password must contain at least one special character.' };
        }

        if (value.length < 8) {
            return { passwordStrength: 'Password must be at least 8 characters long.' };
        }

        if (value.length > 15) {
            return { passwordStrength: 'Password must not exceed 15 characters.' };
        }

        return null; // No errors
    }

    ngOnInit() {
    }

    togglePasswordVisibility(): void {
        this.hidePassword = !this.hidePassword;
    }
    toggleConfirmPasswordVisibility(): void {
        this.hideConfirmPassword = !this.hideConfirmPassword;
    }
    toggleOldPasswordVisibility(): void {
        this.hideOldPassword = !this.hideOldPassword;
    }

    OldPassword(event: any) {
        let pass = event.target.value;
        if (pass.length >= '6') {
            let formData = new FormData();
            formData.append('old_password', event.target.value);
            this.Loader = true;

            this.changepasswordservice.PasswordCheck(event.target.value).subscribe({
                next: (res) => {

                    this.Loader = false;
                    if (res.status_code == "200") {
                        this.OldNotMatch = false;
                    }

                }, error: (err) => {

                    this.Loader = false;
                    this.OldNotMatch = true;

                    if (err.error && err.error.message && err.error.message.password_check) {

                        const errorMessage = err.error.message.password_check.join(', ');

                        this.toastra.error(errorMessage);
                    }

                }
            });
        }
    }

    Submit(formpassword: any) {

        this.errors = {
            oldpassword: '',
            password: '',
            confirmPassword: '',
        };

        // // Validate form
        let isValid = true;

        if (!this.formpassword.oldpassword) {
            this.errors.oldpassword = 'Old Password is required';
            isValid = false;
        }

        if (!this.formpassword.password) {
            this.errors.password = 'New Password is required';
            isValid = false;
        } else {
            // Validate password strength
            const passwordValidationError = this.validatePasswordStrength(this.formpassword.password);
            if (passwordValidationError) {
                this.errors.password = passwordValidationError.passwordStrength!;
                isValid = false;
            }
        }

        if (this.formpassword.password !== this.formpassword.confirmPassword) {
            this.errors.confirmPassword = 'Confirm Password does not match';
            isValid = false;
        }
       
        if (formpassword.valid == true && this.OldNotMatch == false && isValid) {

            if (this.formpassword.oldpassword === this.formpassword.password) {
                this.OldConfirmMatch = true;

                return;
            }
            this.Loader = true;
            let formData = new FormData;

            Object.entries(this.formpassword).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                    formData.append(key, value.toString());
                }
            });

            this.changepasswordservice.UpdatePassword(formData).subscribe({
                next: (res) => {
 
                    this.Loader = false;
                    if (res.status_code == "200") {

                        this.toastra.success(res.message);

                        setTimeout(() => {
                            this.Loader = false;
                            location.reload();
                        }, 1000);
                    }

                }, error: (err) => {

                    this.Loader = false;
                    //  this.OldNotMatch = true;
                    if(err.error.status == "error_validate"){

                        // Check if err.error.message is a string
                        if (typeof err.error.message === 'string') {
                            try {
                                // Parse the JSON string into an object
                                const parsedMessage = JSON.parse(err.error.message);
    
                                // Ensure the parsed message is an object
                                if (typeof parsedMessage === 'object' && parsedMessage !== null) {
                                    // Extract all messages into a single array
                                    const allMessages: string[] = Object.values(parsedMessage).flat() as string[];
    
                                    // Display each message
                                    allMessages.forEach((message) => {
                                        if (typeof message === 'string') {
                                            this.toastra.error(message);
                                        }
                                    });
                                } else {
                                    // Handle unexpected error format
                                    this.toastra.error('An unexpected error occurred.');
                                }
                            } catch (error) {
                                // Handle JSON parsing errors
                                this.toastra.error('An error occurred while processing the error response.');
                            }
    
                        }
                    } else if(err.error.status == "error") {

                    
                        if (err.error && err.error.message) {
    
                            this.toastra.error(err.error.message);
                        }

                    }
                }
            });

        } 
    }


}
